export default __webpack_public_path__ + "static/media/favicon.9c1ec73b.ico";